const getMapRecapText = (slug: VideogameSlug): string => {
  switch (slug) {
    case 'cs-go':
      return 'component_match-recap_map-match';
    case 'dota-2':
      return 'component_match-recap_map-game';
    default:
      return 'component_match-recap_map-game';
  }
};

export { getMapRecapText };
